import {
  KpiIncomeWidget,
  KpiExpensesWidget,
  KpiProfitWidget,
  KpiTransactionsWidget,
} from './widgets/KpiWidgets';
import { BudgetAlertsWidget } from './widgets/BudgetAlertsWidget';
import { CurrencyBreakdownWidget } from './widgets/CurrencyBreakdownWidget';
import { TrendsChartWidget, TopCategoriesWidget } from './widgets/ChartWidgets';
import { RecentTransactionsWidget } from './widgets/RecentTransactionsWidget';

// IMPORTANT: keep ids in sync with /app/backend/routers/dashboard.py KNOWN_WIDGET_IDS
export const WIDGET_REGISTRY = {
  'kpi-income': {
    title: 'Income',
    description: 'Total income KPI card',
    Component: KpiIncomeWidget,
    defaultSize: 'small',
  },
  'kpi-expenses': {
    title: 'Expenses',
    description: 'Total expenses KPI card',
    Component: KpiExpensesWidget,
    defaultSize: 'small',
  },
  'kpi-profit': {
    title: 'Net Profit',
    description: 'Profit KPI with FX-converted base',
    Component: KpiProfitWidget,
    defaultSize: 'small',
  },
  'kpi-transactions': {
    title: 'Transaction Count',
    description: 'Total number of transactions',
    Component: KpiTransactionsWidget,
    defaultSize: 'small',
  },
  'budget-alerts': {
    title: 'Budget Alerts',
    description: 'Categories approaching or exceeding monthly limits',
    Component: BudgetAlertsWidget,
    defaultSize: 'large',
  },
  'currency-breakdown': {
    title: 'By Currency',
    description: 'Profit, income & expenses per currency',
    Component: CurrencyBreakdownWidget,
    defaultSize: 'large',
  },
  'trends-chart': {
    title: 'Financial Trends',
    description: 'Income vs expenses vs profit over time',
    Component: TrendsChartWidget,
    defaultSize: 'medium',
  },
  'recent-transactions': {
    title: 'Recent Transactions',
    description: 'Last 5 transactions',
    Component: RecentTransactionsWidget,
    defaultSize: 'medium',
  },
  'top-categories': {
    title: 'Top Expense Categories',
    description: 'Pie chart of expenses by category',
    Component: TopCategoriesWidget,
    defaultSize: 'medium',
  },
};

export const ALL_WIDGET_IDS = Object.keys(WIDGET_REGISTRY);

// CSS column-span class per widget size for a 4-column grid on md+
export const sizeColClass = (size) => {
  switch (size) {
    case 'small':
      return 'md:col-span-1';
    case 'medium':
      return 'md:col-span-2';
    case 'large':
    default:
      return 'md:col-span-4';
  }
};
